import { Fragment, useMemo } from 'react';
import FlexPane from 'presentation/components/flex-pane/index.js';
import CompetitorIcon from 'presentation/components/competitor-icon/index.js';
import Text from 'presentation/components/text/index.js';
import { useCompetitorsIconsQuery } from 'presentation/components/competitor-icon/hooks/index.js';
import { sortParticipants } from 'presentation/components/scoreboard/utils.js';
import { getSeparatorTranslationKey } from 'presentation/formatters/participant-separator/index.js';

const ParticipantsBoard = props => {
    const {
        event,
        mojitoTools: { config, stringResolver },
    } = props;
    const showIcons = config.participantIcons.showParticipantIcons;

    const sortedParticipants = useMemo(
        () => sortParticipants(event?.participants, event?.homeAway),
        [event?.homeAway, event?.participants]
    );
    const { icons } = useCompetitorsIconsQuery({
        config: config.competitorIconOptions,
        competitors: showIcons ? sortedParticipants : undefined,
        sportId: event?.sportId,
    });

    const separator = (
        <FlexPane config={config.teamNameSeparator}>
            {stringResolver.resolveString(getSeparatorTranslationKey(event.homeAway))}
        </FlexPane>
    );

    return (
        <FlexPane config={config.container}>
            <FlexPane config={config.teamNamesContainer}>
                {sortedParticipants.map((participant, index) => (
                    <Fragment key={participant.id}>
                        <ParticipantItem
                            {...props}
                            participant={participant}
                            src={icons[index]}
                            showIcon={showIcons}
                        />
                        {index < sortedParticipants.length - 1 && separator}
                    </Fragment>
                ))}
            </FlexPane>
        </FlexPane>
    );
};

const ParticipantItem = props => {
    const {
        mojitoTools: { config },
        participant,
        src,
        showIcon,
    } = props;

    return (
        <FlexPane config={config.teamName}>
            {showIcon && (
                <CompetitorIcon
                    title={participant?.name}
                    config={config.competitorIcon}
                    src={src}
                />
            )}
            <Text config={config.participantNameText}>{participant?.name}</Text>
        </FlexPane>
    );
};

export default ParticipantsBoard;
